export default {
      id: "ic_time_status-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic_time_status-usage",
      toString: function () {
        return this.url;
      }
    }